<template>
  <a-card title="趋势指标" style="margin-top: 5px">
    <a-table :columns="columns" :data-source="data"
             rowKey="id"
             size="small"
             :loading="confirmLoading"
             :pagination="false"
             :scroll="{y:'300px'}"
    >
      <span slot="action" slot-scope="text,record,index">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
      </span>
    </a-table>
    <a-button  type="primary" @click="handleAdd" >添加</a-button>
    <a-modal
      title="编辑"
      :width="1000"
      :visible="formVisible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel">
      <a-form-model :model="formData" layout="horizontal" ref="ruleForm" :rules="rules" style="padding-left: 20px;padding-right: 20px;"
                    v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
          }"
      >
        <a-form-model-item label="指标名称" prop="name">
          <a-input v-model="formData.name" placeholder="请输入"/>
        </a-form-model-item>

        <a-form-model-item label="表单" prop="formId">
          <a-select v-model="formData.formId" placeholder="请选择" @change="formIdChange" showSearch
                    :filterOption="filterOption"
          >
            <a-select-option :value="item.id" v-for="item in formList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="元素" prop="formItemId">
          <a-select v-model="formData.formItemId" placeholder="请选择" showSearch
                    :filterOption="filterOption"
          >
            <a-select-option :value="item.id" v-for="item in formItemList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sortNum">
          <a-input-number v-model="formData.sortNum" :min="0" :precision="0" style="width: 80%"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import { getAction,deleteAction,postAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'TendencyList',
    data(){
      return{
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        confirmLoading:false,
        formVisible:false,
        formData:{},
        rules:{
          name:[baseRules.required],
          formId:[baseRules.requiredChange],
          formItemId:[baseRules.requiredChange],
          sortNum:[baseRules.required],
        },
        data:[],
        formList:[],
        formItemList:[],
        columns:[
          {
            title: '指标名称',
            align:'center',
            dataIndex: 'name',
          },
          {
            title: '表单',
            align:'center',
            dataIndex: 'formName',
          },
          {
            title: '元素',
            align:'center',
            dataIndex: 'formItemName',
          },
          {
            title: '排序',
            align:'center',
            dataIndex: 'sortNum',
          },
          {
            title: '操作',
            align:'center',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
      }
    },
    mounted(){
      getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.formList=res.result
        }
      })
      this.loadData()
    },
    methods:{
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      formIdChange(){
        if(this.formData.formId){
          getAction('/project/projectFormItem/listAll',{formId:this.formData.formId}).then(res=>{
            if(res.success){
              this.formItemList = res.result
            }
          })
        }else{
          this.formItemList = []
        }
      },
      loadData(){
        getAction('/project/projectTrendIndicator/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.data=res.result
          }
        })
      },
      handleEdit(record){
        this.formData = Object.assign({},record)
        this.formVisible = true
      },
      handleAdd(){
        this.handleEdit({projectId:this.projectId,sortNum:1})
      },
      handleDelete(id){
        deleteAction('/project/projectTrendIndicator/delete',{id:id}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      handleSubmit(){
        this.$refs.ruleForm.validate(valid  => {
          if(valid){
            postAction('/project/projectTrendIndicator/saveOrUpdate',this.formData).then(res=>{
              if(res.success){
                this.loadData()
                this.handleCancel()
              }
            })
          }

        })
      },
      handleCancel(){
        this.formData = {}
        this.formVisible = false
      },
    },
  }
</script>

<style scoped>

</style>